import { render, staticRenderFns } from "./BLabel.vue?vue&type=template&id=422f0bf0&"
import script from "./BLabel.vue?vue&type=script&lang=js&"
export * from "./BLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports